// JsFromRoutes CacheKey 5200c37ab76ebd32030ca98069fc60d9
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/tasks'),
  create: /* #__PURE__ */ definePathHelper('post', '/api/workspace/:venue_slug/tasks'),
  new: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/tasks/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/tasks/:id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/tasks/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/api/workspace/:venue_slug/tasks/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/api/workspace/:venue_slug/tasks/:id'),
}
